<template>
  <v-dialog v-model="isActive" v-bind="$attrs" persistent max-width="500px">
    <v-card>
      <v-card-title class="text-h6 mr-4" style="word-break: break-word;">
        {{ modalMessage }}
      </v-card-title>
      <v-card-text>
        <div v-if="errorReport" class="error--text">
          {{ errorReport }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" :disabled="!report" @click="onClose">
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CollectorUploadApi } from '@/api/resources/Collector/CollectorUpload'

export default {
  name: 'UploadCollectorVPRFileModal',
  inheritAttrs: false,
  props: {
    file: {
      type: File,
      required: true,
    },
    publicationId: {
      type: Number,
      required: true,
    },
    publicationPartId: {
      type: Number,
      required: true,
    },
    taskKey: {
      type: String,
      required: true,
    },
    updateSha: Function,
  },
  data: () => ({
    errorReport: null,
    report: null,
    isActive: false,
  }),
  computed: {
    modalMessage() {
      if (!this.report) {
        return 'Пожалуйста, не покидайте страницу, иначе загрузка прервется.'
      }
      if (this.errorReport) {
        return 'Произошла ошибка'
      }

      return 'Файл загружен'
    },
  },
  methods: {
    open() {
      this.isActive = true
      this.upload()
      return Promise.resolve()
    },
    async upload() {
      this.report = null
      this.errorReport = null
      try {
        const api = new CollectorUploadApi()
        const { data } = await api.uploadVPRFile(
          this.file,
          this.publicationId,
          this.publicationPartId,
          this.taskKey,
        )
        this.report = data
        this.updateSha(data.file.sha1_sum)
        return data
      } catch (e) {
        this.errorReport = 'Не удалось загрузить файл'
        this.report = true
        this.$notice.errors(e)
        return Promise.reject(e)
      }
    },
    onClose() {
      this.isActive = false
      if (!!this.report && !this.errorReport) {
        this.$emit('success')
      }
    },
  },
}
</script>
